import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CardModule } from 'primeng/card';
import { HomeS } from '../../_core/home';
import { AppBuildInfoService } from '../../_core/app-build-info.service';

@Component({
  selector: 'app-help',
  imports: [CardModule],
  templateUrl: './help.html',
  styleUrl: './help.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Help {
  private $home = inject(HomeS);
  protected readonly buildInfo = inject(AppBuildInfoService);

  public manualList: { url: string; label: string }[] = [
    {
      url: 'https://ov.gomezgroupmetering.com/files/manualPropietarios.pdf',
      label: 'Manual de uso',
    },
  ];

  private readonly allGuides = [
    { url: 'https://www.youtube.com/watch?v=ybla6WzfRlI', label: 'Entiende tu liquidación' },
  ];

  public guideList = computed(() =>
    this.$home.homeData()?.hasBilling === true ? this.allGuides : [],
  );

  public openUrl(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
